import React from 'react';
import ReactDOM from 'react-dom';
import { Spinner } from '@amzn/awsui-components-console';

import App from './components/App';
import { LabAuthProvider } from './components/contexts/LabAuthContext';
import './index.scss';

// The Suspense component causes React to display the fallback Spinner until
// the i18n translation strings have been loaded.
const renderApp = () => {
    ReactDOM.render(
        <React.StrictMode>
            <LabAuthProvider>
                <React.Suspense fallback={<Spinner size="large" />}>
                    <App />
                </React.Suspense>
            </LabAuthProvider>
        </React.StrictMode>,
        document.getElementById('root')
    );
};

if (window.loom && window.loom.loaded) {
    renderApp();
} else {
    // Ensure the application rendering prior to the Loom navigation/authentication
    // Reference: https://w.amazon.com/bin/view/ADSOT/LEAP/Loom/Portal/ConsoleOnboardingGuide/
    const loomNav = document.getElementById('mosaic-navigation');
    const handleLoadEvent = (e) => {
        renderApp();
        loomNav?.removeEventListener('mosaic.loaded', handleLoadEvent);
    };
    loomNav?.addEventListener('mosaic.loaded', handleLoadEvent);
}
